rimg.shopify.init('[data-rimg="lazy"]', { round: 1 });

const sections = new ShopifySectionsManager();

sections.register('age-gate', section => new AgeGate.PageAgeGate(section));

const ageGatePage = document.getElementById('age-gate-page');

if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}

// Document ready
$(() => {

  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }

        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');

          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }

            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');

  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const { target } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }

  $('body')
    .on('change', '#tag_filter', () => {
      $('[data-option-filter] input').prop('checked', false);
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#blog_filter', function () {
      const url = $(this).val();
      window.location = url;
    });

  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: ($('.content').offset().top),
    }, 500);
  });

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
  }

  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, { offset: '70%' });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, { offset: '70%' });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, { offset: '70%' });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, { offset: '70%' });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');

  window.utils.initializeTabs();
  window.accordion.init();

  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning }</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);

    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.product-list');
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('.product-list');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID,
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      },
    });
  }

  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
          + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">'
              + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        if (item.properties) {
          cartItemsHTML += '<div class="mini-cart__item-properties">';
          $.each(item.properties, (title, value) => {
            if (value && value !== 'on') {
              cartItemsHTML += `<div class="mini-cart__item-property">${title}: ${value}</div>`;
            }
          });
          cartItemsHTML += '</div>';
        }

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `/products/${item.handle}.js`,
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price && productData.compare_at_price > productData.price) {
              productHasSale = true;
              productCompareAtPrice = productData.compare_at_price;
              productFinalPrice = productData.price;
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        if (productHasSale === true) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          totalSaving = saving + totalSaving;
        } else if (item.price > item.final_price) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
          if (item.price > 0) {
            cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
          }
        }

        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div></div></div>';
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');
      this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

      $('.warning').remove();

      if (this.recipientForm) {
        this.recipientForm.classList.remove('recipient-form--has-errors');
      }

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error: XMLHttpRequest => {
          const response = eval(`(${XMLHttpRequest.responseText})`);

          $('.warning').remove();

          let warning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            warning = `<p class="warning animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
            $addToCartForm.after(warning);
          }

          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });
  }

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t, e) { const o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? `0${o}` : o; } if (typeof window.Shopify === 'undefined') window.Shopify = {}; window.Shopify.each = function (t, e) { for (let o = 0; o < t.length; o++)e(t[o], o); }, window.Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o; }, window.Shopify.arrayIncludes = function (t, e) { for (let o = 0; o < t.length; o++) if (t[o] == e) return !0; return !1; }, window.Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e; }, window.Shopify.isDefined = function (t) { return typeof t === 'undefined' ? !1 : !0; }, window.Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1); }, window.Shopify.extend = function (t, e) { function o() {}o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype; }, window.Shopify.locationSearch = function () { return window.location.search; }, window.Shopify.locationHash = function () { return window.location.hash; }, window.Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t); }, window.Shopify.urlParam = function (t) { const e = RegExp(`[?&]${t}=([^&#]*)`).exec(window.Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, ' ')); }, window.Shopify.newState = function (t, e) { let o; return o = window.Shopify.urlParam(t) ? window.Shopify.locationSearch().replace(RegExp(`(${t}=)[^&#]+`), `$1${e}`) : window.Shopify.locationSearch() === '' ? `?${t}=${e}` : `${window.Shopify.locationSearch()}&${t}=${e}`, o + window.Shopify.locationHash(); }, window.Shopify.setParam = function (t, e) { window.Shopify.replaceState(window.Shopify.newState(t, e)); }, window.Shopify.Product = function (t) { window.Shopify.isDefined(t) && this.update(t); }, window.Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property]; }, window.Shopify.Product.prototype.optionNames = function () { return window.Shopify.getClass(this.options) == 'Array' ? this.options : []; }, window.Shopify.Product.prototype.optionValues = function (t) { if (!window.Shopify.isDefined(this.variants)) return null; const e = window.Shopify.map(this.variants, e => { const o = `option${t + 1}`; return void 0 == e[o] ? null : e[o]; }); return e[0] == null ? null : window.Shopify.uniq(e); }, window.Shopify.Product.prototype.getVariant = function (t) { let e = null; return t.length != this.options.length ? e : (window.Shopify.each(this.variants, o => { for (var i = !0, r = 0; r < t.length; r++) { const n = `option${r + 1}`; o[n] != t[r] && (i = !1); } return i == 1 ? void (e = o) : void 0; }), e); }, window.Shopify.Product.prototype.getVariantById = function (t) { for (let e = 0; e < this.variants.length; e++) { const o = this.variants[e]; if (t == o.id) return o; } return null; }, window.Shopify.money_format = '$', window.Shopify.formatMoney = function (t, e) { function o(t, e) { return typeof t === 'undefined' ? e : t; } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ','), r = o(r, '.'), isNaN(t) || t == null) return 0; t = (t / 100).toFixed(e); const n = t.split('.'); const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`); const s = n[1] ? r + n[1] : ''; return a + s; } typeof t === 'string' && (t = t.replace('.', '')); let r = ''; const n = /\{\{\s*(\w+)\s*\}\}/; const a = e || this.money_format; switch (a.match(n)[1]) { case 'amount': r = i(t, 2); break; case 'amount_no_decimals': r = i(t, 0); break; case 'amount_with_comma_separator': r = i(t, 2, '.', ','); break; case 'amount_with_apostrophe_separator': r = i(t, 2, "'", '.'); break; case 'amount_no_decimals_with_comma_separator': r = i(t, 0, '.', ','); } return a.replace(n, r); }, window.Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = 'selector-wrapper', this.selectorClass = 'single-option-selector', this.variantIdFieldIdSuffix = '-variant-id', this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new window.Shopify.Product(e.product), this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new window.Shopify.OptionSelectors.HistoryState(this)), !0; }, window.Shopify.OptionSelectors.prototype.initDropdown = function () { const t = { initialLoad: !0 }; const e = this.selectVariantFromDropdown(t); if (!e) { const o = this; setTimeout(() => { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t); }); } }, window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { const e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t); }, window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) { const e = document.getElementById(t); const o = e.parentNode; window.Shopify.each(this.buildSelectors(), t => { o.insertBefore(t, e); }), e.style.display = 'none', this.variantIdField = e; }, window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { let e = document.getElementById(this.domIdPrefix).querySelector('[selected]'); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; const o = e.value; return this.selectVariant(o, t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { const e = window.Shopify.urlParam('variant'); return this.selectVariant(e, t); }, window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { const o = this.product.getVariantById(t); if (o == null) return !1; for (let i = 0; i < this.selectors.length; i++) { const r = this.selectors[i].element; const n = r.getAttribute('data-option'); const a = o[n]; a != null && this.optionExistInSelect(r, a) && (r.value = a); } return typeof jQuery !== 'undefined' ? jQuery(this.selectors[0].element).trigger('change', e) : this.selectors[0].element.onchange(e), !0; }, window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (let o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0; }, window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { window.Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = `product-${this.product.id}-variant-selector`; const o = document.getElementById(t); window.Shopify.each(this.buildSelectors(), t => { o.appendChild(t); }); }, window.Shopify.OptionSelectors.prototype.buildSelectors = function () { for (let t = 0; t < this.product.optionNames().length; t++) { const e = new window.Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e); } const o = this.selectorDivClass; const i = this.product.optionNames(); const r = window.Shopify.map(this.selectors, t => { const e = document.createElement('div'); if (e.setAttribute('class', o), i.length > 1) { const r = document.createElement('label'); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r); } return e.appendChild(t.element), e; }); return r; }, window.Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { const o = this.selectors[e].element.value; t.push(o); } return t; }, window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { const o = this.selectedValues(); const i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), this.historyState != null && this.historyState.onVariantChange(i, this, e); }, window.Shopify.OptionSelectorsFromDOM = function (t, e) { const o = e.optionNames || []; const i = e.priceFieldExists || !0; const r = e.delimiter || '/'; const n = this.createProductFromSelector(t, o, i, r); e.product = n, window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e); }, window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM, window.Shopify.OptionSelectors), window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!window.Shopify.isDefined(o)) var o = !0; if (!window.Shopify.isDefined(i)) var i = '/'; const r = document.getElementById(t); const n = r.childNodes; let a = (r.parentNode, e.length); const s = []; window.Shopify.each(n, (t, r) => {
    if (t.nodeType == 1 && t.tagName.toLowerCase() == 'option') {
      const n = t.innerHTML.split(new RegExp(`\\s*\\${i}\\s*`)); e.length == 0 && (a = n.length - (o ? 1 : 0)); const p = n.slice(0, a); const l = o ? n[a] : ''; const c = (t.getAttribute('value'), {
        available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2],
      }); s.push(c);
    }
  }); const p = { variants: s }; if (e.length == 0) { p.options = []; for (let l = 0; a > l; l++)p.options[l] = `option ${l + 1}`; } else p.options = e; return p;
}, window.Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement('select'); for (let r = 0; r < i.length; r++) { const n = document.createElement('option'); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n); } return this.element.setAttribute('class', this.multiSelector.selectorClass), this.element.setAttribute('data-option', `option${e + 1}`), this.element.id = `${t.domIdPrefix}-option-${e}`, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i); }, !0; }, window.Shopify.Image = {
  preload(t, e) { for (let o = 0; o < t.length; o++) { const i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)); } }, loadImage(t) { (new Image()).src = t; }, switchImage(t, e, o) { if (t && e) { const i = this.imageSize(e.src); const r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r; } }, imageSize(t) { const e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return e != null ? e[1] : null; }, getSizedImageUrl(t, e) { if (e == null) return t; if (e == 'master') return this.removeProtocol(t); const o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (o != null) { const i = t.split(o[0]); const r = o[0]; return this.removeProtocol(`${i[0]}_${e}${r}`); } return null; }, removeProtocol(t) { return t.replace(/http(s)?:/, ''); },
}, window.Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t); }, window.Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener('popstate', e => { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }); }); }, window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || window.Shopify.setParam('variant', t.id)); }, window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState; };

$(document)
  .on('shopify:block:select', e => {
    const { blockId } = e.detail;
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials') || $parentSection.hasClass('shopify-section--shoppable-image--slider-enabled')) {
      sliderBlock.select(blockId, $parentSection);
    }
  });

$(document)
  .on('shopify:block:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
  });

$(document)
  .on('shopify:section:reorder', e => {
    window.utils.initializeSectionWrapper();
  });

$(document)
  .on('shopify:section:load', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.predictiveSearch.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.accordion.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
    }

    if ($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template') || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      window.collectionSidebarFilter.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.sidebarAccordions.init();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.predictiveSearch.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.meganavManager.injectAll();
      window.header.init();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.add($parentSection[0]);
    }
  });

$(document)
  .on('shopify:section:unload', e => {
    const $target = $(e.target);
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.unload($parentSection.find('[data-logo-wrapper]'));
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.predictiveSearch.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
      window.utils.initializeSectionWrapper();
    });
  });

$(document)
  .on('shopify:section:select', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  });

$(document)
  .on('shopify:section:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.deselect();
    }
  });

$('#deskSearch').click(function(e){
  e.preventDefault();
  $('.mobile-search').attr('data-animation-state', 'open');
});

$('.mobile-search-close').click(function(){
  $('.mobile-search').attr('data-animation-state', 'closed');
});
/* ==========================================================
   PPP CART - Custom Cart Drawer (Namespaced + Key-safe)
   Fixes: theme mini-cart script double-firing change.js
   ========================================================== */

/* ===== PPP thresholds from theme settings ===== */
window.pppCompletionMessage = "Congrats! Enjoy a free bookmark + shipping!\u003ci class=\"fa-thin fa-party-horn\" style=\"color:red;font-size:24px;\"\u003e\u003c\/i\u003e";

window.pppCartThresholds = [
  {
    amount: 50,
    ignore_discounts: true,
    icon_message: "FREE Shipping + Bookmark",
    icon: "fa-truck",
    variant: 45752391303212
  },
  {
    amount: 0,
    ignore_discounts: false,
    icon_message: "",
    icon: "",
    variant: 0
  },
  {
    amount: 0,
    ignore_discounts: false,
    icon_message: "",
    icon: "",
    variant: 0
  },
  {
    amount: 0,
    ignore_discounts: false,
    icon_message: "None",
    icon: "fa-circle",
    variant: 0
  },
  {
    amount: 0,
    ignore_discounts: false,
    icon_message: "None",
    icon: "fa-circle",
    variant: 0
  }
].filter(t => Number(t.amount) > 0);
/* ===== end PPP thresholds ===== */

/***********************************************************************
  PPP CART - Base config
***********************************************************************/
const PROMO = window.pppCartPromo || {
  enabled: false,
  triggerIds: [],
  freeId: 0,
  freeSellingPlanId: '',
  startDate: new Date(0),
  allowGiftRemove: true
};

/* ---- Debug + Safe fetch helper ---- */
window.PPP_DEBUG = window.PPP_DEBUG ?? false;

async function pppFetchJSON(url, opts = {}, label = '') {
  try {
    const res = await fetch(url, opts);
    if (!res.ok) {
      let body = null;
      try { body = await res.json(); } catch {
        try { body = await res.text(); } catch {}
      }
      console.error(`[PPPCart] ${label || 'request'} failed`, {
        url, status: res.status, statusText: res.statusText, body
      });
      return { ok: false, status: res.status, body };
    }
    const data = await res.json();
    return { ok: true, data };
  } catch (err) {
    console.error(`[PPPCart] ${label || 'request'} threw`, { url, err });
    return { ok: false, status: 0, body: String(err) };
  }
}

/* ==========================================================
   Stable /cart/change.js helper (form-encoded)
   ========================================================== */
async function pppCartChangeForm(paramsObj, label) {
  const body = new URLSearchParams();
  Object.entries(paramsObj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    body.append(k, String(v));
  });

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: body.toString(),
      credentials: 'same-origin'
    });

    let json = null;
    try { json = await res.json(); } catch {}

    if (!res.ok) {
      const msg = (json && (json.message || json.description)) ? String(json.message || json.description) : '';
      const benign = res.status === 400 && msg.toLowerCase().includes('no valid id or line parameter');

      if (benign && window.PPP_DEBUG) {
        console.warn('[PPPCart] change.js stale line/key; resyncing', { label, paramsObj, json });
      } else {
        console.error('[PPPCart] cart/change failed', { label, status: res.status, paramsObj, json });
      }

      return { ok: false, status: res.status, body: json, benign };
    }

    return { ok: true, data: json };
  } catch (err) {
    console.error('[PPPCart] cart/change threw', { label, err, paramsObj });
    return { ok: false, status: 0, body: String(err), benign: false };
  }
}

/* Key-first change */
function updatePPPCartItemByKey(key, quantity) {
  if (!key || typeof key !== 'string') {
    if (window.PPP_DEBUG) console.warn('[PPPCart] Missing/invalid key; resync', { key, quantity });
    updatePPPCart();
    return Promise.resolve();
  }
  if (!Number.isInteger(quantity) || quantity < 0) quantity = 0;

  return pppCartChangeForm({ id: key, quantity }, 'POST /cart/change.js (by key)')
    .then(res => {
      if (res.ok && res.data && Array.isArray(res.data.items)) {
        refreshPPPCart(res.data);
      } else {
        updatePPPCart();
      }
    });
}

/* Line fallback */
function updatePPPCartItemQuantity(lineID, quantity) {
  if (!Number.isInteger(lineID) || lineID < 1) return Promise.resolve();
  if (!Number.isInteger(quantity) || quantity < 0) quantity = 0;

  return pppCartChangeForm({ line: lineID, quantity }, 'POST /cart/change.js (by line)')
    .then(res => {
      if (res.ok && res.data && Array.isArray(res.data.items)) {
        refreshPPPCart(res.data);
      } else {
        updatePPPCart();
      }
    });
}

/* Promo gift suppression */
window._pppGiftSuppressed = window._pppGiftSuppressed || {};
window._promoRequesting = window._promoRequesting || false;

/* ==========================================================
   Drawer open/close
   ========================================================== */
document.addEventListener('DOMContentLoaded', function() {
  const pppCartEl = document.getElementById('ppp-cart');
  if (!pppCartEl) return;

  document.addEventListener('click', function(e) {
    const closeBtn = e.target.closest('[data-ppp-cart-close]');
    if (closeBtn) {
      pppCartEl.classList.remove('is-visible');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      const smileContainer = document.getElementById('smile-ui-lite-container');
      if (smileContainer) smileContainer.style.removeProperty('display');
      return;
    }

    const triggerEl = e.target.closest('[data-ppp-cart-trigger]');
    if (triggerEl) {
      e.preventDefault();
      e.stopPropagation();

      updatePPPCart();
      pppCartEl.classList.add('is-visible');

      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      const smileContainer = document.getElementById('smile-ui-lite-container');
      if (smileContainer) smileContainer.style.setProperty('display', 'none', 'important');
    }
  });
});

/* ==========================================================
   Cart fetch + render
   ========================================================== */
let _pppCartUpdateTimer = null;
let _pppCartUpdateInFlight = false;
let _pppCartUpdatePending = false;

function updatePPPCart() {
  if (_pppCartUpdateTimer) clearTimeout(_pppCartUpdateTimer);

  _pppCartUpdateTimer = setTimeout(async () => {
    if (_pppCartUpdateInFlight) {
      _pppCartUpdatePending = true;
      return;
    }

    _pppCartUpdateInFlight = true;
    const res = await pppFetchJSON('/cart.js', { credentials: 'same-origin' }, 'GET /cart.js');
    _pppCartUpdateInFlight = false;

    if (!res.ok || !res.data || !Array.isArray(res.data.items)) {
      console.warn('[PPPCart] Skipping render; invalid cart payload.', res);
      return;
    }

    refreshPPPCart(res.data);

    const smileContainer = document.getElementById('smile-ui-lite-container');
    if (smileContainer) smileContainer.style.setProperty('display', 'none', 'important');

    if (_pppCartUpdatePending) {
      _pppCartUpdatePending = false;
      updatePPPCart();
    }
  }, 150);
}

/* ==========================================================
   Render cart (namespaced DOM so theme mini-cart JS won’t bind)
   ========================================================== */
function refreshPPPCart(cart) {
  if (!cart || !Array.isArray(cart.items)) return;

  // update header badges that you already use
  document.querySelectorAll('.cart_count').forEach(el => {
    el.innerText = cart.item_count;
  });

  const cartContentEl = document.querySelector('[data-ppp-cart-content]');
  const emptyStateEl  = document.querySelector('[data-ppp-empty-state]');
  const itemsEl       = document.querySelector('[data-ppp-cart-items]');
  const footer        = document.querySelector('.ppp-cart__flyout-footer');
  const subtotalRow   = footer?.querySelector('.ppp-cart__flyout-subtotal');
  const itemCountEl   = document.querySelector('[data-ppp-cart-item-count]');
  if (!cartContentEl || !itemsEl || !footer || !subtotalRow) return;

  // visuals
  updateProgressBar(cart);
  renderTiers(cart);

  // promos
  autoAddFreeItem(cart);
  handleFreeItemPromo(cart);

  // empty state
  if (cart.item_count === 0) {
    cartContentEl.classList.add('no-items');
    if (emptyStateEl) emptyStateEl.style.display = 'block';
    itemsEl.innerHTML = '';

    footer.querySelector('[data-ppp-cart-subtotal]').textContent = '$0.00';
    if (itemCountEl) itemCountEl.textContent = '0';

    const existingSavings = footer.querySelector('.ppp-cart__saving');
    if (existingSavings) existingSavings.style.display = 'none';
    return;
  }

  cartContentEl.classList.remove('no-items');
  if (emptyStateEl) emptyStateEl.style.display = 'none';

  const moneyFmt = document.body.dataset.moneyFormat || window.Shopify.money_format || '$';

  const cfg = window.pppCartPromo || {};
  const promoFreeId = Number(cfg.freeId || 0);
  const allowGiftRemove = (cfg.allowGiftRemove === true);

  const thresholdGiftIds = new Set(
    (window.pppCartThresholds || []).map(t => String(t.variant || '')).filter(Boolean)
  );

  let html = '';

  cart.items.forEach((item, i) => {
    const shopifyLine = i + 1; // stable enough for fallback only

    let msg = '';
    (item.discounts || []).forEach(d => {
      msg += `<p class="notification-discount meta">${d.title}</p>`;
    });

    const propsHTML = buildPropertiesHtml(item.properties);

    let title = item.product_title || item.title;
    if (item.variant_title && title.endsWith(" - " + item.variant_title)) {
      title = title.slice(0, -(item.variant_title.length + 3));
    }

    const vHTML = (item.variant_title && item.variant_title !== title)
      ? `<div class="ppp-cart__flyout-item-variant">${item.variant_title}</div>`
      : '';

    const sellingPlanName = item.selling_plan_allocation?.selling_plan?.name || '';
    const sellingPlanHTML = sellingPlanName
      ? `<div class="meta">${htmlEncode(String(sellingPlanName))}</div>`
      : '';

    const isGift = !!(item.properties && item.properties._pppGift === '1');
    const keyAttr = (item.key || '');

    if (isGift) {
      const isPromoGift = promoFreeId && Number(item.id) === promoFreeId;
      const isThresholdGift = thresholdGiftIds.has(String(item.id));
      const showPromoTrash = allowGiftRemove && isPromoGift && !isThresholdGift;

      html += `
      <div class="ppp-cart__flyout-item free-item"
           data-ppp-cart-item
           data-key="${keyAttr}"
           data-ppp-line="${shopifyLine}"
           data-variant-id="${item.id}"
           data-ppp-gift="1">
        <div class="ppp-cart__flyout-item-media">
          <img src="${item.image||'//placehold.it/80x80'}" alt="${htmlEncode(title)}"/>
        </div>
        <div class="ppp-cart__flyout-item-info">
          <h4 class="ppp-cart__flyout-item-product-title"><span>${title}</span></h4>
          ${vHTML}${sellingPlanHTML}${msg}${propsHTML}
          <div class="ppp-cart__flyout-item-bottom-row">
            <div class="ppp-cart__flyout-item-price" data-price-container>
              <span>${(window.PXUTheme?.translation?.cart_free_text) || 'FREE'}</span>
              <span class="money was_price"></span>
            </div>
          </div>
          ${showPromoTrash ? `
            <button type="button"
                    class="ppp-cart__flyout-item-remove"
                    data-ppp-remove
                    aria-label="Remove free promo item">
                    <svg class="ppp-cart__remove-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false">
                      <path fill="currentColor" d="M144 32h160l24 64h88c17.7 0 32 14.3 32 32v24c0 8.8-7.2 16-16 16h-16l-21.2 296.9C392.4 491.4 370.3 512 343.7 512H104.3c-26.6 0-48.7-20.6-51.1-47.1L32 168H16c-8.8 0-16-7.2-16-16v-24c0-17.7 14.3-32 32-32h88l24-64zm45.3 48l-6 16h81.4l-6-16h-69.4zM128 224v192c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24s-24 10.7-24 24zm72 0v192c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24s-24 10.7-24 24zm72 0v192c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/>
                    </svg>
            </button>
          ` : ``}
        </div>
      </div>`;
    } else {
      html += `
      <div class="ppp-cart__flyout-item"
           data-ppp-cart-item
           data-key="${keyAttr}"
           data-ppp-line="${shopifyLine}"
           data-variant-id="${item.id}">
        <div class="ppp-cart__flyout-item-media">
          <a href="${item.url}">
            <img src="${item.image||'//placehold.it/80x80'}" alt="${htmlEncode(title)}"/>
          </a>
        </div>
        <div class="ppp-cart__flyout-item-info">
          <h4 class="ppp-cart__flyout-item-product-title">
            <a href="${item.url}">${title}</a>
          </h4>
          ${vHTML}${sellingPlanHTML}${msg}${propsHTML}
          <div class="ppp-cart__flyout-item-bottom-row">
            <div class="ppp-cart__flyout-item-quantity">
              <span data-ppp-qty-minus class="ppp-qty-minus">
                <i class="fa-regular fa-minus"></i>
              </span>
              <input type="number"
                     data-ppp-qty-input
                     value="${item.quantity}"
                     min="0">
              <span data-ppp-qty-plus class="ppp-qty-plus">
                <i class="fa-regular fa-plus"></i>
              </span>
            </div>
            <div class="ppp-cart__flyout-item-price" data-price-container>
              <span>Loading price...</span>
            </div>
          </div>
            <button type="button"
                    class="ppp-cart__flyout-item-remove"
                    data-ppp-remove
                    aria-label="Remove item">
                    <svg class="ppp-cart__remove-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false">
                      <path fill="currentColor" d="M144 32h160l24 64h88c17.7 0 32 14.3 32 32v24c0 8.8-7.2 16-16 16h-16l-21.2 296.9C392.4 491.4 370.3 512 343.7 512H104.3c-26.6 0-48.7-20.6-51.1-47.1L32 168H16c-8.8 0-16-7.2-16-16v-24c0-17.7 14.3-32 32-32h88l24-64zm45.3 48l-6 16h81.4l-6-16h-69.4zM128 224v192c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24s-24 10.7-24 24zm72 0v192c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24s-24 10.7-24 24zm72 0v192c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/>
                    </svg>
            </button>
        </div>
      </div>`;
    }
  });

  itemsEl.innerHTML = html;
  if (itemCountEl) itemCountEl.textContent = cart.item_count;

  /* ---- Subtotal + was-total placeholder ---- */
  footer.querySelector('[data-ppp-cart-subtotal]').innerHTML = `
    ${Shopify.formatMoney(cart.total_price, moneyFmt)}
    <span class="ppp-cart__was-total" style="text-decoration: line-through; margin-left: 10px;">
      ${Shopify.formatMoney(0, moneyFmt)}
    </span>`;

  /* ---- Savings line ---- */
  let savingsEl = footer.querySelector('.ppp-cart__saving');
  if (!savingsEl) {
    savingsEl = document.createElement('div');
    savingsEl.className = 'ppp-cart__saving';
    savingsEl.style.textAlign = 'center';
    savingsEl.style.margin = '0px 0';
    savingsEl.style.color = 'red';
    savingsEl.style.fontStyle = 'italic';
    footer.insertBefore(savingsEl, subtotalRow);
  }
  savingsEl.textContent = `You’re Saving ${Shopify.formatMoney(0, moneyFmt)}`;

  /* ---- Per-line prices + compute was-total ---- */
  let totalWasPrice = 0;

  function setPriceHTMLForRow(rowKey, html) {
    const pc = document.querySelector(`[data-ppp-cart-item][data-key="${rowKey}"] [data-price-container]`);
    if (pc) pc.innerHTML = html;
  }

  const pricePromises = cart.items.map(item => {
    const rowKey = item.key;
    const isGiftRow = !!(item.properties && item.properties._pppGift === '1');

    return pppFetchJSON(`/products/${item.handle}.js`, { credentials: 'same-origin' }, `GET /products/${item.handle}.js`)
      .then(prod => {
        const saleCents = (typeof item.discounted_price === 'number') ? item.discounted_price : item.final_price;
        const wasFallback = (typeof item.original_price === 'number') ? item.original_price : item.price;

        if (!prod.ok || !prod.data) {
          const fallbackHTML = (isGiftRow || saleCents === 0)
            ? `<span>${(window.PXUTheme?.translation?.cart_free_text) || 'FREE'}</span>
               <span class="money was_price">${Shopify.formatMoney(wasFallback, moneyFmt)}</span>`
            : `<span class="money">${Shopify.formatMoney(saleCents, moneyFmt)}</span>
               <span class="money was_price">${Shopify.formatMoney(wasFallback, moneyFmt)}</span>`;
          setPriceHTMLForRow(rowKey, fallbackHTML);
          totalWasPrice += wasFallback * item.quantity;
          return;
        }

        const v = (prod.data.variants || []).find(v => v.id === item.id);
        if (!v) return;

        const wasCents = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;

        const priceHTML = (isGiftRow || saleCents === 0)
          ? `<span>${(window.PXUTheme?.translation?.cart_free_text) || 'FREE'}</span>
             <span class="money was_price">${Shopify.formatMoney(wasCents, moneyFmt)}</span>`
          : `<span class="money sale">${Shopify.formatMoney(saleCents, moneyFmt)}</span>
             <span class="money was_price">${Shopify.formatMoney(wasCents, moneyFmt)}</span>`;

        setPriceHTMLForRow(rowKey, priceHTML);
        totalWasPrice += wasCents * item.quantity;
      })
      .catch(err => console.error("PPPCart price error:", err));
  });

  Promise.all(pricePromises).then(() => {
    const wasTotalEl = footer.querySelector('.ppp-cart__was-total');
    if (wasTotalEl) wasTotalEl.innerHTML = Shopify.formatMoney(totalWasPrice, moneyFmt);

    const savingsCents = totalWasPrice - cart.total_price;
    if (savingsCents > 0) {
      savingsEl.textContent = `You’re Saving ${Shopify.formatMoney(savingsCents, moneyFmt)}`;
      savingsEl.style.display = '';
    } else {
      savingsEl.style.display = 'none';
    }
  });

  /* ---- Currency conversion ---- */
  if (
    window.PXUTheme &&
    window.PXUTheme.currency &&
    window.PXUTheme.currency.show_multiple_currencies &&
    window.currencyConverter &&
    typeof window.currencyConverter.convertCurrencies === 'function'
  ) {
    window.currencyConverter.convertCurrencies();
  }

  /* ---- Upsells ---- */
  loadUpsellProducts();

  /* ---- Multi-buy buttons (unchanged logic, but DOM selector uses namespaced rows) ---- */
  renderMultiBuyButtons(cart);
}

/* ==========================================================
   Upsells
   ========================================================== */
function loadUpsellProducts() {
  fetch('/?section_id=ppp-upsell-products', { credentials: 'same-origin' })
    .then(r => r.text())
    .then(html => {
      const upsellContainer = document.querySelector('[data-ppp-recommendations]');
      if (upsellContainer) upsellContainer.innerHTML = html;
    })
    .catch(err => console.error('Error loading upsell products:', err));
}

/* ==========================================================
   Multi-buy buttons
   ========================================================== */
function renderMultiBuyButtons(cart) {
  if (!window.pppMultiBuy || !window.pppMultiBuy.enabled) return;

  document.querySelectorAll('.ppp-cart__buy-tiers').forEach(el => el.remove());

  const TIER_VARIANTS = (window.pppMultiBuy.variantIds || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  const TIERS = window.pppMultiBuy.tiers || [];

  const combinedQty = cart.items
    .filter(item => TIER_VARIANTS.includes(String(item.id)))
    .reduce((sum, item) => sum + item.quantity, 0);

  cart.items.forEach((item) => {
    if (!TIER_VARIANTS.includes(String(item.id))) return;

    const btnsHTML = TIERS
      .filter(t => combinedQty < t.qty)
      .map(t => `
        <button type="button"
                class="ppp-cart__buy-tier-button"
                data-ppp-buy-tier
                data-ppp-buy-qty="${t.qty}">
          ${t.text}
        </button>
      `).join('');

    if (!btnsHTML) return;

    const infoEl = document.querySelector(
      `[data-ppp-cart-item][data-key="${item.key}"] .ppp-cart__flyout-item-info`
    );
    if (!infoEl) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'ppp-cart__buy-tiers';
    wrapper.innerHTML = btnsHTML;
    infoEl.appendChild(wrapper);
  });
}

/* ==========================================================
   Properties + encoding helpers
   ========================================================== */
function buildPropertiesHtml(propsObj) {
  if (!propsObj) return '';
  const keys = Object.keys(propsObj);
  if (!keys.length) return '';
  let html = `<div class="mini-cart__item-properties">`;

  keys.forEach(key => {
    if (key.indexOf('__appstle-') === 0) return;
    if (key.charAt(0) === '_') return;

    const val = propsObj[key];
    if (val && val !== 'on') {
      html += `<div class="mini-cart__item-property">${key}: ${val}</div>`;
    }
  });

  html += `</div>`;
  return html;
}

function htmlEncode(str) {
  const div = document.createElement('div');
  div.appendChild(document.createTextNode(str || ''));
  return div.innerHTML;
}
/* ==========================================================
   Progress bar + tiers
   ========================================================== */

function pppThresholdAmount(t) {
  const amount = Number(t && t.amount);
  return Number.isFinite(amount) ? amount : 0;
}

function pppIsPPPGift(item) {
  return !!(item && item.properties && item.properties._pppGift === '1');
}

function pppIsPhysicalCartItem(item) {
  if (!item) return false;

  const ships = (typeof item.requires_shipping === 'boolean') ? item.requires_shipping : null;
  const type = (item.product_type || '').toLowerCase();

  return (ships === true) || (ships === null && type === 'physical');
}

function pppMoneyCents(value, fallback = 0) {
  const cents = Number(value);
  return Number.isFinite(cents) ? Math.max(cents, 0) : fallback;
}

function pppNormalizeDiscountValue(value) {
  return String(value || '')
    .toLowerCase()
    .trim();
}

function pppDiscountIdentityParts(discount) {
  if (!discount) return [];

  const app = discount.discount_application || {};

  return [
    discount.title,
    discount.code,
    discount.name,
    discount.key,
    discount.description,
    app.title,
    app.code,
    app.name,
    app.key,
    app.description
  ]
    .map(pppNormalizeDiscountValue)
    .filter(Boolean);
}

function pppDiscountText(discount) {
  return pppDiscountIdentityParts(discount).join(' ');
}

function pppLooksLikeOrderDiscountApplication(discountApplication) {
  if (!discountApplication) return false;

  const targetType = pppNormalizeDiscountValue(discountApplication.target_type);
  const targetSelection = pppNormalizeDiscountValue(discountApplication.target_selection);
  const allocationMethod = pppNormalizeDiscountValue(discountApplication.allocation_method);

  /*
    This is only a fallback for carts/themes that do not expose
    cart_level_discount_applications clearly.

    Shopify order/cart discounts commonly get allocated across all line items,
    which can make them appear inside line_level_discount_allocations.
  */
  return (
    targetType === 'shipping_line' ||
    targetType === 'cart' ||
    (
      targetType === 'line_item' &&
      targetSelection === 'all' &&
      allocationMethod === 'across'
    )
  );
}

function pppGetOrderDiscountApplications(cart) {
  if (!cart) return [];

  const apps = [];

  /*
    This is the main source of truth for order/cart-level discounts.
    These should NEVER reduce progress bar qualification.
  */
  if (Array.isArray(cart.cart_level_discount_applications)) {
    apps.push(...cart.cart_level_discount_applications);
  }

  /*
    Fallback only. Some cart payloads expose discount applications here.
    I only use this fallback when cart_level_discount_applications is empty.
  */
  if (!apps.length && Array.isArray(cart.discount_applications)) {
    apps.push(...cart.discount_applications.filter(pppLooksLikeOrderDiscountApplication));
  }

  return apps;
}

function pppGetOrderDiscountMatcherSet(cart) {
  const apps = pppGetOrderDiscountApplications(cart);
  const matchers = new Set();

  apps.forEach(app => {
    pppDiscountIdentityParts(app).forEach(part => {
      matchers.add(part);
    });

    const text = pppDiscountText(app);
    if (text) matchers.add(text);
  });

  return matchers;
}

function pppIsOrderDiscountAllocation(discount, orderDiscountMatchers) {
  if (!discount || !orderDiscountMatchers || !orderDiscountMatchers.size) return false;

  const parts = pppDiscountIdentityParts(discount);
  const text = pppDiscountText(discount);

  if (text && orderDiscountMatchers.has(text)) return true;

  return parts.some(part => orderDiscountMatchers.has(part));
}

function pppGetOriginalLineCents(item) {
  if (!item) return 0;

  const qty = Number(item.quantity || 1);

  return pppMoneyCents(
    item.original_line_price != null
      ? item.original_line_price
      : item.original_price != null
        ? item.original_price * qty
        : item.line_price != null
          ? item.line_price
          : 0
  );
}

function pppDiscountAmountCents(discount) {
  if (!discount) return 0;

  return pppMoneyCents(
    discount.amount != null
      ? discount.amount
      : discount.allocated_amount != null
        ? discount.allocated_amount
        : discount.total_allocated_amount != null
          ? discount.total_allocated_amount
          : 0
  );
}

function pppGetProductDiscountCents(item, cart) {
  if (!item) return 0;

  const orderDiscountMatchers = pppGetOrderDiscountMatcherSet(cart);

  /*
    These arrays can include order/cart discount allocations too.
    I filter those out so the progress bar only counts true product discounts.
  */
  const lineLevelDiscounts = Array.isArray(item.line_level_discount_allocations)
    ? item.line_level_discount_allocations
    : [];

  const legacyLineDiscounts = Array.isArray(item.discounts)
    ? item.discounts
    : [];

  const discounts = lineLevelDiscounts.length
    ? lineLevelDiscounts
    : legacyLineDiscounts;

  return discounts
    .filter(discount => {
      return !pppIsOrderDiscountAllocation(discount, orderDiscountMatchers);
    })
    .reduce((sum, discount) => {
      return sum + pppDiscountAmountCents(discount);
    }, 0);
}

function pppGetProductDiscountedLineCents(item, cart) {
  if (!item) return 0;

  const originalLineCents = pppGetOriginalLineCents(item);
  const productDiscountCents = pppGetProductDiscountCents(item, cart);

  /*
    This intentionally calculates:

    original line price - product/line-item discounts only

    Order/cart-level discounts are ignored, even if Shopify allocates them
    back onto individual line items after the order discount is applied.
  */
  return Math.max(originalLineCents - productDiscountCents, 0);
}

function pppGetLineCents(item, ignoreProductDiscounts, cart) {
  if (!item) return 0;

  /*
    The threshold setting means:
    - true  = ignore product/line-item discounts
    - false = count product/line-item discounts

    Order/cart-level discounts are always ignored either way.
  */
  return ignoreProductDiscounts
    ? pppGetOriginalLineCents(item)
    : pppGetProductDiscountedLineCents(item, cart);
}

function computeSubtotal(cart, ignoreProductDiscounts) {
  if (!cart || !Array.isArray(cart.items)) return 0;

  const subtotalCents = cart.items
    .filter(item => {
      if (!item) return false;

      // PPP gift items should never count toward earning thresholds.
      if (pppIsPPPGift(item)) return false;

      // Only physical/shippable items count toward thresholds.
      if (!pppIsPhysicalCartItem(item)) return false;

      const cents = pppGetLineCents(item, !!ignoreProductDiscounts, cart);
      return cents > 0;
    })
    .reduce((sum, item) => {
      return sum + pppGetLineCents(item, !!ignoreProductDiscounts, cart);
    }, 0);

  return subtotalCents / 100;
}

function pppGetThresholdGiftLine(cart, threshold) {
  if (!cart || !Array.isArray(cart.items) || !threshold) return null;

  const vid = parseInt(threshold.variant, 10);
  if (!vid) return null;

  return cart.items.find(item =>
    Number(item.id) === vid &&
    item.properties &&
    item.properties._pppGift === '1'
  ) || null;
}

function pppGetVisualThresholdSubtotal(cart, threshold) {
  const amount = pppThresholdAmount(threshold);
  const subtotal = computeSubtotal(cart, !!threshold.ignore_discounts);

  /*
    I keep an already-earned threshold visually unlocked while its PPP gift
    is still in the cart. This prevents the gift's own free-item/order discount
    from making the progress bar jump backward.

    Order/cart-level discounts are ignored for progress qualification.
  */
  const giftLine = pppGetThresholdGiftLine(cart, threshold);

  if (giftLine) {
    return Math.max(subtotal, amount);
  }

  return subtotal;
}

function pppGetSortedThresholds() {
  return (window.pppCartThresholds || [])
    .filter(t => pppThresholdAmount(t) > 0)
    .slice()
    .sort((a, b) => pppThresholdAmount(a) - pppThresholdAmount(b));
}

function pppGetHighestCompletedVisualAmount(cart, thresholds) {
  return thresholds.reduce((highest, threshold) => {
    const amount = pppThresholdAmount(threshold);
    const subtotal = pppGetVisualThresholdSubtotal(cart, threshold);

    return subtotal >= amount ? Math.max(highest, amount) : highest;
  }, 0);
}

function updateProgressBar(cart) {
  if (!cart || !Array.isArray(cart.items)) return;

  const thresholds = pppGetSortedThresholds();
  if (!thresholds.length) return;

  const maxAmt = Math.max(...thresholds.map(pppThresholdAmount));
  const highestCompletedAmount = pppGetHighestCompletedVisualAmount(cart, thresholds);

  const next = thresholds.find(t => {
    return pppGetVisualThresholdSubtotal(cart, t) < pppThresholdAmount(t);
  });

  const fillSub = next
    ? Math.max(pppGetVisualThresholdSubtotal(cart, next), highestCompletedAmount)
    : maxAmt;

  const pct = Math.min((fillSub / maxAmt) * 100, 100);

  const fillEl = document.querySelector('.ppp-cart__progress-bar-meter-fill');
  if (fillEl) fillEl.style.width = pct + '%';

  const promptEl = document.querySelector('.ppp-cart__progress-bar-prompt');
  if (!promptEl) return;

  if (next) {
    const nextAmount = pppThresholdAmount(next);
    const sub = Math.max(pppGetVisualThresholdSubtotal(cart, next), highestCompletedAmount);
    const left = Math.max(nextAmount - sub, 0).toFixed(2);
    const label = next.icon_message || '';

    promptEl.innerHTML = `You’re <strong>$${left}</strong> away from ${label}!`;
  } else {
    promptEl.innerHTML = window.pppCompletionMessage || 'Unlocked!';
  }
}

function renderTiers(cart) {
  try {
    const thresholds = pppGetSortedThresholds();
    if (!thresholds.length) return;

    const maxAmt = Math.max(...thresholds.map(pppThresholdAmount)) || 1;
    const container = document.querySelector('.ppp-cart__tiers-container');
    if (!container) return;

    container.innerHTML = thresholds.map(t => {
      const amount = pppThresholdAmount(t);
      const sub = pppGetVisualThresholdSubtotal(cart, t);
      const pct = (amount / maxAmt) * 100;
      const doneClass = sub >= amount ? 'completed' : '';

      return `
        <div class="ppp-cart__tier" style="left: ${pct}%">
          <div class="ppp-cart__tier-circle ${doneClass}">
            <i class="fa ${t.icon}"></i>
          </div>
          <div class="ppp-cart__tier-desc">${t.icon_message}</div>
        </div>
      `;
    }).join('');
  } catch (err) {
    console.error('PPPCart › renderTiers:', err);
  }
}

/* ==========================================================
   Threshold gifts (remove by KEY to avoid stale lines)
   ========================================================== */
async function autoAddFreeItem(cart) {
  if (!cart || !Array.isArray(cart.items)) return;

  const thresholds = pppGetSortedThresholds();
  if (!thresholds.length) return;

  window._pppRequesting   = window._pppRequesting || {};
  window._pppBlockedUntil = window._pppBlockedUntil || {};
  window._pppAvailCache   = window._pppAvailCache || {};

  const isBlocked = (vid) => (Date.now() < (window._pppBlockedUntil[vid] || 0));
  const blockFor  = (vid, ms) => { window._pppBlockedUntil[vid] = Date.now() + ms; };

  async function isVariantAvailable(vid) {
    if (vid in window._pppAvailCache) return window._pppAvailCache[vid];

    const res = await pppFetchJSON(`/variants/${vid}.js`, { credentials: 'same-origin' }, `GET /variants/${vid}.js`);
    const ok = !!(res.ok && res.data && res.data.id && res.data.available !== false);

    window._pppAvailCache[vid] = ok;
    return ok;
  }

  for (const t of thresholds) {
    const vid = parseInt(t.variant, 10);
    if (!vid) continue;

    const amount = pppThresholdAmount(t);

    /*
      Gift add/remove uses the real qualifying subtotal, not the visually
      locked subtotal.

      The threshold setting only controls product/line-item discounts.
      Order/cart-level discounts are always ignored.
    */
    const sub = computeSubtotal(cart, !!t.ignore_discounts);

    const giftLine = cart.items.find(i =>
      Number(i.id) === vid &&
      i.properties &&
      i.properties._pppGift === '1'
    );

    const inCart = Boolean(giftLine);
    const meets = sub >= amount;

    if (isBlocked(vid)) continue;

    if (meets && !inCart && !window._pppRequesting[vid]) {
      const available = await isVariantAvailable(vid);

      if (!available) {
        blockFor(vid, 10 * 60 * 1000);
        continue;
      }

      window._pppRequesting[vid] = true;

      const addRes = await pppFetchJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: vid,
          quantity: 1,
          properties: { _pppGift: '1' }
        }),
        credentials: 'same-origin'
      }, `POST /cart/add.js (threshold gift ${vid})`);

      window._pppRequesting[vid] = false;

      if (!addRes.ok) {
        const ms = addRes.status === 429 ? 2 * 60 * 1000 : 10 * 60 * 1000;
        blockFor(vid, ms);
        continue;
      }

      updatePPPCart();
      continue;
    }

    if (!meets && inCart && giftLine && giftLine.key) {
      await updatePPPCartItemByKey(giftLine.key, 0);
    }
  }
}

/* ==========================================================
   PROMO: trigger-based free item (key removal + suppression)
   ========================================================== */
function handleFreeItemPromo(cart) {
  const cfg = window.pppCartPromo || {};
  if (!cfg.enabled) return;
  if (!Array.isArray(cfg.triggerIds) || !cfg.triggerIds.length) return;
  if (new Date() < cfg.startDate) return;
  if (!cfg.freeId) return;
  if (!cart || !Array.isArray(cart.items)) return;

  const triggerIds = cfg.triggerIds.map(x => Number(x)).filter(Boolean);
  const freeId = Number(cfg.freeId);
  const freeSellingPlanId = Number(cfg.freeSellingPlanId || 0);

  const hasTrigger = cart.items.some(item => triggerIds.includes(Number(item.id)));

  const promoGiftItems = cart.items.filter(item =>
    Number(item.id) === freeId && item.properties && item.properties._pppGift === '1'
  );

  if (!hasTrigger) {
    delete window._pppGiftSuppressed[String(freeId)];

    const giftToRemove = promoGiftItems[0];
    if (giftToRemove && giftToRemove.key) {
      updatePPPCartItemByKey(giftToRemove.key, 0);
    }
    return;
  }

  const matchingFreeItem = promoGiftItems.find(item => {
    if (!freeSellingPlanId) return true;

    const itemSellingPlanId = Number(
      item.selling_plan_allocation?.selling_plan?.id || 0
    );
    return itemSellingPlanId === freeSellingPlanId;
  });

  const staleFreeItem = freeSellingPlanId
    ? promoGiftItems.find(item => {
        const itemSellingPlanId = Number(
          item.selling_plan_allocation?.selling_plan?.id || 0
        );
        return itemSellingPlanId !== freeSellingPlanId;
      })
    : null;

  if (staleFreeItem && staleFreeItem.key) {
    updatePPPCartItemByKey(staleFreeItem.key, 0);
    return;
  }

  if (matchingFreeItem && Number(matchingFreeItem.quantity) !== 1 && matchingFreeItem.key) {
    updatePPPCartItemByKey(matchingFreeItem.key, 1);
    return;
  }

  if (!matchingFreeItem) {
    if (window._pppGiftSuppressed[String(freeId)]) return;
    if (window._promoRequesting) return;

    window._promoRequesting = true;

    const promoLine = {
      id: freeId,
      quantity: 1,
      properties: { _pppGift: '1' }
    };

    if (freeSellingPlanId) {
      promoLine.selling_plan = freeSellingPlanId;
    }

    pppFetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [promoLine] }),
      credentials: 'same-origin'
    }, 'POST /cart/add.js (promo gift)')
      .then(r => { if (r.ok) updatePPPCart(); })
      .catch(e => console.error('Add promo free item failed:', e))
      .finally(() => { window._promoRequesting = false; });

    return;
  }
}

/* ==========================================================
   IMPORTANT: PPP controls click handler (CAPTURE PHASE)
   Stops theme mini-cart JS from handling PPP clicks.
   ========================================================== */
document.addEventListener('click', function(e) {
  const pppCartEl = document.getElementById('ppp-cart');
  if (!pppCartEl) return;

  // only intercept clicks inside PPP cart drawer
  if (!pppCartEl.contains(e.target)) return;

  const removeBtn = e.target.closest('[data-ppp-remove]');
  const minusBtn  = e.target.closest('[data-ppp-qty-minus]');
  const plusBtn   = e.target.closest('[data-ppp-qty-plus]');
  const buyBtn    = e.target.closest('[data-ppp-buy-tier]');
  const upsellBtn = e.target.closest('.ppp-upsell-add-button');

  if (!(removeBtn || minusBtn || plusBtn || buyBtn || upsellBtn)) return;

  // stop other cart systems from also firing
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

  // BUY-TIER
  if (buyBtn) {
    const targetQty = parseInt(buyBtn.getAttribute('data-ppp-buy-qty') || '0', 10);
    const rowEl = buyBtn.closest('[data-ppp-cart-item]');
    if (!rowEl || !targetQty) return;

    const key = rowEl.getAttribute('data-key') || '';
    const line = parseInt(rowEl.getAttribute('data-ppp-line') || '0', 10);

    if (key) return updatePPPCartItemByKey(key, targetQty);
    if (line) return updatePPPCartItemQuantity(line, targetQty);
    return;
  }

  // UPSELL ADD
  if (upsellBtn) {
    const variantId = upsellBtn.getAttribute('data-variant-id');
    const productId = upsellBtn.getAttribute('data-product-id');

    if (variantId) {
      pppFetchJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
        credentials: 'same-origin'
      }, `POST /cart/add.js (upsell variant ${variantId})`).then(res => {
        if (!res.ok) return;
        updatePPPCart();
        scrollCartToTop();
      });
      return;
    }

    if (productId) {
      const upsellItem = upsellBtn.closest('.upsell-item-wrapper');
      if (!upsellItem) return;

      const selectWrapper = upsellItem.querySelector('.upsell-item-bottom-row');
      if (!selectWrapper) return;

      if (selectWrapper.style.display === 'none' || selectWrapper.style.display === '') {
        selectWrapper.style.display = 'block';
        upsellBtn.textContent = 'ADD';
        return;
      }

      const selectElem = selectWrapper.querySelector('.ppp-upsell-variant-select');
      if (!selectElem) return;

      const selectedVariantId = selectElem.value;
      if (!selectedVariantId) return;

      pppFetchJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
        credentials: 'same-origin'
      }, `POST /cart/add.js (upsell variant ${selectedVariantId})`).then(res => {
        if (!res.ok) return;
        updatePPPCart();
        scrollCartToTop();
      });
    }

    return;
  }

  // QTY +/- (non-gift only)
  if (minusBtn || plusBtn) {
    const rowEl = (minusBtn || plusBtn).closest('[data-ppp-cart-item]');
    if (!rowEl) return;

    if (rowEl.hasAttribute('data-ppp-gift')) return;

    const key = rowEl.getAttribute('data-key') || '';
    const line = parseInt(rowEl.getAttribute('data-ppp-line') || '0', 10);

    const input = rowEl.querySelector('[data-ppp-qty-input]');
    if (!input) return;

    let qty = parseInt(input.value, 10) || 0;
    qty = minusBtn ? Math.max(0, qty - 1) : qty + 1;
    input.value = qty;

    if (key) return updatePPPCartItemByKey(key, qty);
    if (line) return updatePPPCartItemQuantity(line, qty);
    return;
  }

  // REMOVE
  if (removeBtn) {
    const rowEl = removeBtn.closest('[data-ppp-cart-item]');
    if (!rowEl) return;

    const isGift = rowEl.hasAttribute('data-ppp-gift');
    const key = rowEl.getAttribute('data-key') || '';
    const line = parseInt(rowEl.getAttribute('data-ppp-line') || '0', 10);
    const vid = Number(rowEl.getAttribute('data-variant-id') || 0);

    const cfg = window.pppCartPromo || {};
    const promoFreeId = Number(cfg.freeId || 0);
    const allowGiftRemove = (cfg.allowGiftRemove === true);

    if (isGift) {
      // Only promo gift is removable
      if (!allowGiftRemove || !promoFreeId || vid !== promoFreeId) return;

      // suppress re-add until trigger removed
      window._pppGiftSuppressed[String(promoFreeId)] = true;

      if (key) return updatePPPCartItemByKey(key, 0);
      if (line) return updatePPPCartItemQuantity(line, 0);
      updatePPPCart();
      return;
    }

    if (key) return updatePPPCartItemByKey(key, 0);
    if (line) return updatePPPCartItemQuantity(line, 0);
    updatePPPCart();
  }
}, true); // <-- CAPTURE PHASE

/* Manual qty edit */
document.addEventListener('change', function(e) {
  const input = e.target.closest('[data-ppp-qty-input]');
  if (!input) return;

  const pppCartEl = document.getElementById('ppp-cart');
  if (!pppCartEl || !pppCartEl.contains(input)) return;

  const rowEl = input.closest('[data-ppp-cart-item]');
  if (!rowEl) return;
  if (rowEl.hasAttribute('data-ppp-gift')) return;

  let qty = parseInt(input.value, 10) || 0;
  const key = rowEl.getAttribute('data-key') || '';
  const line = parseInt(rowEl.getAttribute('data-ppp-line') || '0', 10);

  if (key) return updatePPPCartItemByKey(key, qty);
  if (line) return updatePPPCartItemQuantity(line, qty);
}, true);

/* ==========================================================
   Add-to-cart forms => AJAX add + open drawer
   ========================================================== */
document.addEventListener('DOMContentLoaded', function() {
  const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');

  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      const productForm = form.closest('[data-product-form]');

      if (productForm && productForm.getAttribute('data-ppp-see-options-enabled') === 'true') {
        try {
          const targetIds = String(productForm.getAttribute('data-ppp-see-options-target-ids') || '').split(',');
          const productId = String(productForm.getAttribute('data-product-id') || '');
          const variantId = String(formData.get('id') || '');

          for (let i = 0; i < targetIds.length; i++) {
            const targetId = targetIds[i].replace(/\s/g, '');
            if (targetId && (targetId === productId || targetId === variantId)) {
              return;
            }
          }
        } catch (error) {
          if (window.console && typeof window.console.warn === 'function') {
            window.console.warn('SEE OPTIONS cart guard was skipped:', error);
          }
        }
      }

      pppFetchJSON('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      }, 'POST /cart/add.js (form add)').then(res => {
        if (!res.ok) return;

        updatePPPCart();
        scrollCartToTop();

        const pppCartEl = document.getElementById('ppp-cart');
        if (pppCartEl) pppCartEl.classList.add('is-visible');
      }).catch(error => {
        console.error('Error adding product to cart (form):', error);
      });
    });
  });
});

/* Announcement slider */
document.addEventListener('DOMContentLoaded', function() {
  var announcementSlider = document.getElementById('announcement-slider');
  if (announcementSlider) {
    new Splide('#announcement-slider', {
      type: 'loop',
      autoplay: true,
      interval: 4000,
      pauseOnHover: true,
      arrows: false,
      pagination: false,
    }).mount();
  }
});

function scrollCartToTop() {
  const topAnchor = document.getElementById('cart-top-anchor');
  if (topAnchor) topAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* Legacy globals */
window.freeItemAlreadyAdded = false;
window.freeItemRequestInFlight = false;

/* ==========================================================
   PPP CART - Open drawer instead of going to /cart for links
   ========================================================== */
document.addEventListener('click', function(e) {
  const link = e.target.closest('a');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href) return;

  const isCartLink =
    href === '/cart' ||
    href === '/cart/' ||
    href.startsWith('/cart?') ||
    href.startsWith('/cart#');

  if (!isCartLink) return;

  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }

  updatePPPCart();

  const pppCartEl = document.getElementById('ppp-cart');
  if (pppCartEl) {
    pppCartEl.classList.add('is-visible');
  }

  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';

  const smileContainer = document.getElementById('smile-ui-lite-container');
  if (smileContainer) {
    smileContainer.style.setProperty('display', 'none', 'important');
  }
}, true);

/* ==========================================================
   PPP CART - Open drawer when URL contains ?open_ppp_cart=1
   ========================================================== */
document.addEventListener('DOMContentLoaded', function() {
  const url = new URL(window.location.href);

  if (url.searchParams.get('open_ppp_cart') !== '1') return;

  updatePPPCart();

  const pppCartEl = document.getElementById('ppp-cart');
  if (pppCartEl) {
    pppCartEl.classList.add('is-visible');
  }

  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';

  const smileContainer = document.getElementById('smile-ui-lite-container');
  if (smileContainer) {
    smileContainer.style.setProperty('display', 'none', 'important');
  }

  url.searchParams.delete('open_ppp_cart');
  window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
});
